import React from "react";

export const CommonContext = React.createContext();

export const useCommonContext = () => React.useContext(CommonContext);
